import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Container, Alert, AlertTitle } from '@material-ui/core';
import { OpenIdContext } from '../contexts/OpenIdContext';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.array, // Example ['admin', 'leader']
  children: PropTypes.node
};

export default function RoleBasedGuard({ accessibleRoles, children }) {
  const { role } = useContext(OpenIdContext);
  // if (!role || !accessibleRoles.filter((x) => role.includes(x)).length) {

  if (!role) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
